import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBOQl9lXCGa4hMrYVXeYyGVGrSeLSlxgMU",
  authDomain: "pmt-bd-subt-598r2eb.firebaseapp.com",
  projectId: "pmt-bd-subt-598r2eb",
  storageBucket: "pmt-bd-subt-598r2eb.firebasestorage.app",
  messagingSenderId: "389257670902",
  appId: "1:389257670902:web:978585452a3109803e7cd7",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Persistence set to browserLocalPersistence");
  })
  .catch((error) => {
    console.error("Error setting persistence:", error.code, error.message);
  });

const googleProvider = new GoogleAuthProvider();
const firestore = getFirestore(app);

export { auth, googleProvider, firestore };
